import React, { useState } from 'react';

const LABELS = {
  en: { services: 'Services', audit: 'Audit', contact: 'Contact', cta: 'Request a Discovery Call',
        toggle_group: 'Language', to_en: 'Change language to English', to_es: 'Change language to Spanish' },
  es: { services: 'Servicios', audit: 'Auditoría', contact: 'Contacto', cta: 'Solicitar una llamada de descubrimiento',
        toggle_group: 'Idioma', to_en: 'Cambiar idioma a inglés', to_es: 'Cambiar idioma a español' },
};

const HeaderV2 = ({ language = 'en', onLanguageChange, buildHref }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const t = LABELS[language] || LABELS.en;
  const href = (target) => (typeof buildHref === 'function' ? buildHref(target) : target);
  const items = [
    { key: 'services', href: href('/v2/services'), label: t.services },
    { key: 'audit',    href: href('/v2/audit'),    label: t.audit },
    { key: 'contact',  href: href('/v2/contact'),  label: t.contact },
  ];
  return (
    <header className="iv2-header" data-testid="iv2-header">
      <div className="iv2-container iv2-header-inner">
        <a href={href('/')} className="iv2-logo" data-testid="iv2-logo" aria-label="illumi.dev home">
          <span>illumi</span><span className="iv2-logo-accent">.dev</span>
        </a>

        <nav className={`iv2-nav ${menuOpen ? 'iv2-nav-open' : ''}`} data-testid="iv2-nav" aria-label="Primary">
          {items.map((it) => (
            <a key={it.key} href={it.href} data-testid={`iv2-nav-${it.key}`} onClick={() => setMenuOpen(false)}>
              {it.label}
            </a>
          ))}
          <a href={href('/v2/audit')} className="iv2-nav-cta" data-testid="iv2-nav-cta" onClick={() => setMenuOpen(false)}>
            {t.cta}
          </a>
          <div role="group" aria-label={t.toggle_group} className="iv2-header-lang" data-testid="iv2-header-lang">
            <button
              type="button"
              className={`iv2-header-lang-btn ${language === 'en' ? 'is-active' : ''}`}
              aria-pressed={language === 'en'}
              aria-label={t.to_en}
              onClick={() => onLanguageChange && onLanguageChange('en')}
              data-testid="iv2-header-lang-en"
            >EN</button>
            <button
              type="button"
              className={`iv2-header-lang-btn ${language === 'es' ? 'is-active' : ''}`}
              aria-pressed={language === 'es'}
              aria-label={t.to_es}
              onClick={() => onLanguageChange && onLanguageChange('es')}
              data-testid="iv2-header-lang-es"
            >ES</button>
          </div>
        </nav>

        <button type="button" className="iv2-menu-btn" onClick={() => setMenuOpen((v) => !v)}
          aria-expanded={menuOpen} aria-label={menuOpen ? 'Close menu' : 'Open menu'} data-testid="iv2-menu-btn">
          {menuOpen ? '× MENU' : '≡ MENU'}
        </button>
      </div>
    </header>
  );
};

export default HeaderV2;
